// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import { Breadcrumb, Card, Col, Row, Tab } from 'react-bootstrap';

// import custom components
// import sub components
import ElevesListItems from './ElevesListItems';
import SalledeclasseService from '../../../services/SalledeclasseService';
import { Link, useParams } from 'react-router-dom';

const BulletinnotesEleves = () => {
	const { id } = useParams();
	const [salledeclasse, setSalledeclasse] = useState(null);

	useEffect(() => {
		const fetchSalledeclasse = async () => {
			try {
				const response = await SalledeclasseService.getSalledeclasse(id);
				setSalledeclasse(response.data); // Here, response.data is probably an object, not an array.
			} catch (error) {
				console.error('Error fetching salle de classe data', error);
			}
		};

		fetchSalledeclasse();
	}, [id]);

	function formatIntituleClasse(value) {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	}

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">Bulletin de notes</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">Accueil</Breadcrumb.Item>
									<Breadcrumb.Item href="/pedagogie/notes/">
										Bulletin de notes
									</Breadcrumb.Item>
									<Breadcrumb.Item active>
										{salledeclasse
											? formatIntituleClasse(
													salledeclasse.intitule_classe
											  ).toUpperCase()
											: ''}
									</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="mb-3 mb-md-0">
								<Link
									to={`/pedagogie/notes/`}
									className={`btn btn-outline-dark btn-sm d-none d-md-block`}
								>
									Retour à la liste des classes
								</Link>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>
					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* BulletinnotesEleves in list view */}
								<ElevesListItems />
								{/* end of BulletinnotesEleves in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default BulletinnotesEleves;
